<template>
  <div class="fundPoolManagementVO">
    <div class="poolofmoney-infoBox">
      <div class="poolofmoney-moneyInfo">
        <p style="color: #828BAF;">{{ $t("poolofmoney.topName1") }}</p>
        <p style="margin-top:15px;">
          {{ data.totalAmount | formatNum }}
        </p>
      </div>
      <div class="poolofmoney-moneyInfo">
        <p style="color: #828BAF;">{{ $t("poolofmoney.topName2") }}</p>
        <p style="margin-top:15px;">
          {{ data.lockAmount | formatNum }}
        </p>
      </div>
      <div class="poolofmoney-moneyInfo">
        <p style="color: #828BAF;">{{ $t("poolofmoney.topName3") }}</p>
        <p style="margin-top:15px;">
          {{ data.useAmount | formatNum }}
        </p>
      </div>
      <div class="poolofmoney-moneyInfo">
        <p style="color: #828BAF;">{{ $t("poolofmoney.topName4") }}</p>
        <p style="margin-top:15px;">
          {{ data.availableBalance | formatNum }}
        </p>
      </div>
    </div>
    <el-row>
      <el-button
        v-if="addBtn"
        type="primary"
        class="pool-btn-primary"
        style="margin-left:435px;"
        @click="showAddMoneyDialog(true)"
      >{{ $t("poolOfMoney_page.addMoney") }}</el-button
      >
      <el-button
        v-if="reduceBtn"
        class="pool-btn-default"
        style="margin-left:30px;"
        @click="showAddMoneyDialog(false)"
      >{{ $t("poolOfMoney_page.delMoney") }}</el-button
      >
    </el-row>
    <!-- 资金池管理列表 -->
    <div class="fundPoolManagement-tableBox">
      <table class="fundPoolManagement-table">
        <thead>
          <tr>
            <th style="width:104px;text-align:left;padding-left: 30px;box-sizing: border-box">
              {{ $t("financingFundList.indexTr") }}
            </th>
            <th style="width:207px">
              {{ $t("poolOfMoney_page.amountOfFunds") }}(US$)
            </th>
            <th style="width:246px">
              {{ $t("poolOfMoney_page.totalAmount") }}(US$)
            </th>
            <th style="width:198px">
              {{ $t("poolOfMoney_page.type") }}
            </th>
            <th style="width:285px">{{ $t("poolOfMoney_page.opetime") }}</th>
            <th style="width:160px">{{ $t("poolOfMoney_page.operator") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in manageList.rows" :key="index">
            <td style="max-width:104px;text-align:left;padding-left: 30px;box-sizing: border-box">
              {{ index + 1 + (pg_st - 1) * 10 }}
            </td>
            <td style="max-width:207px;">
              {{ item.handleBalance | formatNum }}
            </td>
            <td style="max-width:246px;">{{ item.totalFund | formatNum }}</td>
            <td style="max-width:198px;">
              <span v-show="item.handleType !== 1">{{
                $t("poolOfMoney_page.del")
              }}</span>
              <span v-show="item.handleType == 1">{{
                $t("poolOfMoney_page.add")
              }}</span>
            </td>
            <td style="max-width:285px;">
              {{ item.createTime | dateTimeConvert }}
            </td>
            <td>
              {{ item.loanAccountName }}
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 当列表数据为空时显示界面 -->
      <div
        v-if="!manageList.rows || !manageList.rows.length"
        class="statusEmpty"
      >
        <i/>{{ $t("frontPage.noData") }}
      </div>
      <!-- 翻页 -->
      <div class="fundPoolManagement-pagination-box">
        <el-pagination
          v-if="manageList.rows && manageList.rows.length"
          :page-size="10"
          :total="total"
          :current-page.sync="pg_st"
          style="text-align:center;"
          background
          layout="prev, pager, next"
          class="page-theme"
          @current-change="getManageList()"
        />
      </div>
    </div>
    <!-- 追加资金、减少资金的对话框 -->
    <el-dialog
      :title="addTitleText + ' '+ $t('poolOfMoney_page.money')"
      :visible.sync="addMoneyDialogVisible"
      width="440px"
      class="addMoneyDlg"
      @close="addMoneyDialogClosed"
    >
      <p style="color: #81899E;text-align:center; margin:25px auto 23px; min-height: 1px;">
        <!--        {{$t("poolOfMoney_page.pleaseInput") }}{{ addTitleText }}{{$t("loan.amount")}}-->
      </p>
      <el-form
        ref="addMoneyFormRef"
        :model="addMoneyForm"
        :rules="addMoneyFormRules"
      >
        <el-form-item prop="moneyNumber" style="maegin:0 ;padding:0;">
          <el-input
            :placeholder="addTitleTextPlaceholder"
            v-model.trim="addMoneyForm.moneyNumber"
            :maxlength="20"
            @blur="inputChanged"
          />
        </el-form-item>
      </el-form>
      <span class="addMoneySpan">
        <!--        取消-->
        <el-button
          class="pool-btn-default"
          style="margin:0;"
          @click="addMoneyDialogVisible = false"
        >{{ $t("poolOfMoney_page.no") }}</el-button
        >
        <!--        确认-->
        <el-button
          class="pool-btn-primary"
          style="margin:0 30px 0;"
          @click="addMoney"
        >{{ $t("poolOfMoney_page.ok") }}</el-button
        >

      </span>
    </el-dialog>
  </div>
</template>
<script>
// import dayjs from "dayjs";
export default {
  name: 'FundPoolManagement',
  props: ['addBtn', 'reduceBtn'],
  // inject:['reload'],
  data() {
    // 验证追加、减少资金规则:最多两位小数，必须为正，减少资金不得大于余额
    const checkMoneyNumber = (rule, value, cb) => {
      const regMoneyNumber = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,4})?$/
      if (!value) {
        return cb(
          new Error(this.addTitleText + this.$t('poolOfMoney_page.moneyNo'))
        )
      } else if (!regMoneyNumber.test(value) || Number(value) > 999999999999.9999) {
        this.addMoneyForm.moneyNumber = ''
        cb(new Error(this.$t('poolOfMoney_page.moneyFormat')))
      } else if (Number(value) > this.data.availableBalance && this.addTitleText === this.$t('poolOfMoney_page.del')) {
        cb(new Error(this.$t('poolOfMoney_page.delMoneyMore')))
      } else {
        cb()
      }
    }
    return {
      addTitleText: '',
      addTitleTextPlaceholder: '',
      addMoneyForm: {
        moneyNumber: ''
      },
      // 追加、减少资金对话框默认关闭
      addMoneyDialogVisible: false,
      // 追加表单的验证规则
      addMoneyFormRules: {
        moneyNumber: [{ validator: checkMoneyNumber, trigger: 'blur' }]
      },
      value: '',
      manageList: {
        rows: []
      },
      data: {},
      // 当前页码
      pg_st: 1,
      total: 0,

      // 版本号
      versionNum: ''
    }
  },
  created() {
    this.getManageList()
  },
  methods: {
    // 输入框格式化
    inputChanged() {
      // 保留两位小数，或三位小数，或四位小数。当value为12.120，则显示12.12
      // 012/12.0/12.000/12.120/12.00001/aaa/12.0000001/0aa/aa0/0

      // if (!isNaN(Number(value)) && value) {
      //   // this.addMoneyForm.moneyNumber = Number(value);
      //   this.addMoneyForm.moneyNumber = this.formatNum(value);
      // }
      this.addMoneyForm.moneyNumber = this.$utils.convertNum(this.addMoneyForm.moneyNumber, 4)
    },
    // 每三位数字进行分割

    formatNum(value) {
      const valueNew = Number(value) + ''
      let intPart
      if (Number(valueNew) >= 0) {
        intPart = Math.floor(Number(valueNew)) // 获取整数部分
      } else if (Number(valueNew) < 0) {
        intPart = Math.ceil(Number(valueNew)) // 获取整数部分
      }
      intPart = intPart + ''
      const intPartFormat = intPart
      let floatPart = '.00' // 预定义小数部分
      const value2Array = valueNew.split('.')
      // =2表示数据有小数位
      if (parseInt(value2Array[1]) > 0) {
        floatPart = value2Array[1] + '' // 拿到小数部分
        if (floatPart.length == 1) {
          return intPartFormat + '.' + floatPart + '0'
        } else {
          return intPartFormat + '.' + floatPart
        }
      } else {
        return intPartFormat + floatPart
      }
    },
    getManageList() {
      const params = {
        pg_st: this.pg_st,
        pg_rs: 10
      }
      this.axios.post('/zma/api/zmaFundingPool/detail', params).then(res => {
        console.log('管理列表')
        console.log(res)
        if (res.status) {
          this.data = res.data
          this.versionNum = res.data.version
          this.manageList.rows = res.data.zmaFundingChangeLogAPIList.rows
          this.total = res.data.zmaFundingChangeLogAPIList.total
        } else {
          this.$message.error(this.$t(`poolOfMoney_error.${res.errorCode}`))
        }
      })
    },
    // 展示追加、减少资金对话框
    showAddMoneyDialog(add) {
      if (add) {
        this.addTitleText = this.$t('poolOfMoney_page.add2')
        this.addTitleTextPlaceholder = this.$t('poolOfMoney_page.inputAdd')
      } else {
        this.addTitleText = this.$t('poolOfMoney_page.del')
        this.addTitleTextPlaceholder = this.$t('poolOfMoney_page.inputDel')
      }
      this.addMoneyDialogVisible = true
    },
    // 关闭对话框时清空数据
    addMoneyDialogClosed() {
      this.$refs.addMoneyFormRef.resetFields()
    },
    // 调用追加资金、减少资金接口
    addMoney() {
      // 校验后调接口在关闭对话框
      this.$refs.addMoneyFormRef.validate(valid => {
        if (!valid) return
        const params = {
          in_ba: this.addMoneyForm.moneyNumber,
          in_ve: this.versionNum
        }
        if (this.addTitleText == this.$t('poolOfMoney_page.add2')) {
          this.axios.post('/zma/api/zmaFundingPool/add', params).then(res => {
            console.log('追加资金')
            console.log(res)
            if (res.status) {
              console.log('追加成功！')
              this.getManageList()
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res.errorCode}`)
              )
              if (res.errorCode == 'loan_audit_50000031') {
                setTimeout(function() {
                  window.location.reload()
                }, 1500)
              }
            }
          })
        } else if (this.addTitleText == this.$t('poolOfMoney_page.del')) {
          this.axios.post('/zma/api/zmaFundingPool/cut', params).then(res => {
            console.log('减少资金')
            console.log(res)
            if (res.status) {
              console.log('减少成功！')
              this.getManageList()
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res.errorCode}`)
              )
              if (res.errorCode == 'loan_audit_50000031') {
                setTimeout(function() {
                  window.location.reload()
                }, 1500)
              }
            }
          })
        }
        this.addMoneyDialogVisible = false
        // this.getManageList()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.addMoneySpan {
  box-sizing: border-box;
  display: inline-block;
  width: 390px;
  height: 70px;
  box-shadow: inset 0 1px 0 0 #eaeaea;
  margin-left: 25px;
  padding-top: 16px;
}
.pool-btn-primary {
  width: 150px;
  height: 38px;
  background: #7996f5;
  border-radius: 2px;
  color: #fff;
}
.pool-btn-default {
  width: 150px;
  height: 38px;
  background: #ffffff;
  border: 1px solid #7996f5;
  border-radius: 2px;
  color: #7996f5;
}
.poolofmoney {
  &-infoBox {
    margin: 0 auto 20px;
    width: 900px;
    height: 100px;
    background: #f8fafd;
  }
  &-moneyInfo {
    display: inline-block;
    margin: 20px 0;
    text-align: center;
    width: 225px;
    height: 60px;
    box-shadow: inset -1px 0 0 0 #e9ebf0;
  }
}
.fundPoolManagement {
  font-size: 14px;
  &-pagination-box {
    padding: 30px 0;
  }
  &-table {
    margin-top: 30px;
    width: 100%;
    border: none;
    font-weight: normal;
    color: #606266;
    text-align: left;
    border-collapse: collapse;
    thead {
      height: 50px;
      line-height: 50px;
      color: #828baf;
      background: #f8fafd;
    }
    th {
      padding: 0;
      height: 50px;
      font-weight: normal;
      text-align: left;
    }
    td {
      height: 60px;
      padding: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
